import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as Arrow } from '../../images/uparrow.svg'
import { ReactComponent as SeatIcon } from '../../images/seaticon.svg'
import DragIndicator from './DragIndicator'
import ArrivalIndicator from './ArrivalIndicator'

const CurrentBooking = ({info, setCurrentBooking, maxSeats}) => {

  //const [dragging, setDragging] = useState(false)
  const dragging = useRef(false)
  const sliding = useRef(false)
  const drag = useRef({
    startY: null,
    y: null,
    startRow: null
  })
  const [isDragging, setIsDragging] = useState(false)
  //const [bottomDrag, setBottomDrag] = useState(false)
  const bottomDrag = useRef(false)
  const [dragOffset, setDragOffset] = useState(0)

  const startColumn = maxSeats + 2 - info.width

  const calculateOffset = () => {
    const deltaY = drag.current.y - drag.current.startY
    return (deltaY / 20) | 0
  }

  const handleDragStart = (evt) => {
    evt.preventDefault()
    
    //console.log('drag start', evt)
    dragging.current = true
    drag.current.startY = evt.pageY
    drag.current.y = evt.pageY
    setIsDragging(true)
    bottomDrag.current = false
  }
  const handleDragStartBottom = (evt) => {
    evt.preventDefault()
    //document.addEventListener('touchmove', handleDrag, {passive:false})
    //document.addEventListener('touchend', preventDefault, {passive:false})
    dragging.current = true
    drag.current.startY = evt.pageY
    drag.current.y = evt.pageY
    setIsDragging(true)
    bottomDrag.current = true
  }
  
  const handleDrag = (evt) => {
    evt.preventDefault()
    if (dragging.current || sliding.current) {
      drag.current.y = evt.pageY
      const deltaY = drag.current.y - drag.current.startY
      const extraColumns = (deltaY / 20) | 0
      //console.log(evt, drag.current.y, deltaY)
      //console.log('dragging', extraColumns, deltaY)
      if (dragging.current) {
        setDragOffset(calculateOffset())

      } else {
        console.log()
        const newRow = Math.max(1, drag.current.startRow + calculateOffset())
        setCurrentBooking(prev => ({...prev, startRow: newRow}))
      }
    }
  }
  
  const handleDragEnd = (evt) => {
    //evt.preventDefault()
    if (dragging.current) {
      //console.log('drag end', evt)
      dragging.current = false
      setCurrentBooking(prev => {
        if (bottomDrag.current) {
          const newData = {...prev, height:prev.height+calculateOffset()}
          console.log(prev, newData)
          return newData
        } else {
          const newRow = Math.max(1, prev.startRow + calculateOffset())
          const newData = {...prev, startRow: newRow, height:prev.height-calculateOffset()}
          console.log(prev, newData)
          return newData
        }
      })
    }
    setIsDragging(false)
    sliding.current = false
    console.log('slide end')
    setDragOffset(0)
  }

  const handleSlideStart = (evt) => {
    evt.preventDefault()
    sliding.current = true
    console.log('slide start')
    drag.current.startY = evt.pageY
    drag.current.y = evt.pageY
    drag.current.startRow = info.startRow
  }

  const handleTouchStart = (evt) => {
    evt.preventDefault()
    console.log('touch start', evt)
    handleDragStart(evt.nativeEvent)
  }
  const handleTouchStartBottom = (evt) => {
    evt.preventDefault()
    console.log('touch start', evt)
    handleDragStartBottom(evt.nativeEvent)
  }
  const handleTouchMove = (evt) => {
    if (sliding.current || dragging.current) {
      evt.preventDefault()
      //console.log('touch move')
      handleDrag(evt)
    }
  }
  const handleTouchEnd = (evt) => {
    //evt.preventDefault()
    console.log('touch end')
    handleDragEnd(evt)
  }


  useEffect(() => {
    //document.addEventListener('mousemove', handleDrag, {passive: false})
    document.addEventListener('pointermove', handleDrag, {passive: false})
    //document.addEventListener('mouseup', handleDragEnd, {passive: false})
    document.addEventListener('pointerup', handleDragEnd, {passive: false})
    //document.addEventListener('touchstart', preventDefault, {passive:false})
    document.addEventListener('touchmove', handleTouchMove, {passive:false})
    document.addEventListener('touchend', handleTouchEnd, {passive:false})
    return () => {
      document.removeEventListener('pointermove', handleDrag)
      document.removeEventListener('pointerup', handleDragEnd)
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchup', handleTouchEnd)
    }
  }, [])



  return (
    <>
    <div className='booking' style={{
      gridColumn: `${startColumn} / span ${info.width}`,
      gridRow: `${info.startRow} / span ${info.height}`,
    }} >
      {[...Array(info.width)].map((_, i) => (
        <div className='seat'>
          <SeatIcon />
        </div>
      ))}
      <div className='drag-target' onMouseDown={handleDragStart} onTouchStart={handleTouchStart}  >
        <Arrow />
      </div>

      {/* <div className='slide-target' onMouseDown={handleSlideStart} onTouchStart={handleSlideStart} > */}
      <div className='slide-target' onPointerDown={handleSlideStart} >
      </div>

      <div className='drag-target bottom' onMouseDown={handleDragStartBottom} onTouchStart={handleTouchStartBottom} >
        <Arrow />
      </div>
    </div>
    {dragging.current && 
      <DragIndicator startColumn={startColumn} dragOffset={dragOffset} bottomDrag={bottomDrag.current} info={info} />
    }
    <ArrivalIndicator info={info} />
    </>
  )
}

export default CurrentBooking
